module.exports = __webpack_public_path__ + "static/mesh-7ae08a79f6ffa51558b33204883c758b.jpg";